import {User} from 'constants/UserConstants';
import {BenchlingAction} from 'redux-stores/Action';

import {UserAdminActionType} from './AdminReduxActions';

export interface UserAdminState {
  organizationId: string | null;
  usersById: {[userId: string]: User};
}

export const ADMIN_INITIAL_STATE = {
  organizationId: null,
  usersById: {},
};

export default function reduceAdminModels(
  state: UserAdminState = ADMIN_INITIAL_STATE,
  action: BenchlingAction
): UserAdminState {
  switch (action.type) {
    case UserAdminActionType.USER_ADMIN_STATE_INITIALIZED: {
      const {organizationId, usersById} = action;
      return {organizationId, usersById};
    }
    case UserAdminActionType.USER_ADMIN_STATE_UPDATED: {
      const {updatedUsersById} = action;
      return {
        ...state,
        usersById: {
          ...state.usersById,
          ...updatedUsersById,
        },
      };
    }
    default:
      return state;
  }
}
